(function(){
 'use strict';
 function init(root){
  if(root.dataset.seeratInit)return;root.dataset.seeratInit='1';
  var source=document.querySelector('product-recommendations.seerat-phase2-recommendations');
  if(!source||!source.dataset.url)return;
  var url=new URL(source.dataset.url,location.origin);
  url.searchParams.set('intent','complementary');
  fetch(url.toString(),{credentials:'same-origin'}).then(function(resp){if(!resp.ok)throw Error('Recommendation request failed');return resp.text()}).then(function(html){
   var parsed=new DOMParser().parseFromString(html,'text/html');
   var cards=parsed.querySelectorAll('.product-recommendations .grid > .grid__item, .product-recommendations .grid > .grid-product');
   if(!cards.length)return;
   var target=root.querySelector('[data-seerat-paired-grid]');if(!target)return;
   cards.forEach(function(card){target.appendChild(document.importNode(card,true));});
   root.hidden=false;
  }).catch(function(){/* No valid complementary products: keep section hidden. */});
 }
 function boot(){document.querySelectorAll('[data-seerat-paired]').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
})();
